import type { RuleHandler } from "../types";
import { setIncludes } from "utilities/promotions/setIncludes";

const checkExcludedEventIds: RuleHandler = (context, requirement) => {
  const requirementAttributes = requirement.userDrivenAttributes;

  return !setIncludes(
    new Set(requirementAttributes?.excludedEventIds),
    new Set(context.selection.eventIds),
  );
};

export { checkExcludedEventIds };
